import { ChangeEvent } from 'react';
import { useLanguage } from '../contexts/LanguageContext';
import { translate } from '../i18n';

const LanguageSwitcher = () => {
  const { locale, setLocale, options } = useLanguage();

  const handleChange = (event: ChangeEvent<HTMLSelectElement>) => {
    setLocale(event.target.value as typeof locale);
  };

  return (
    <label className="language-switcher">
      <span>{translate(locale, 'languageLabel')}</span>
      <select value={locale} onChange={handleChange} aria-label={translate(locale, 'languageLabel')}>
        {options.map((option) => (
          <option key={option.value} value={option.value}>
            {option.label}
          </option>
        ))}
      </select>
    </label>
  );
};

export default LanguageSwitcher;
